import React from "react";

export function EmailField({value, placeholder, onChange}) {

    return <section>
        <label className="input">
            <i className=""></i>
            <input type="email" id="phone_no" data-toggle="tooltip" data-placement="bottom" placeholder={placeholder}
                   value={value}
                   onChange={(event) => onChange && onChange(event.target.value)}
                   required="required"
                   ng-click="phoneFieldClicked()"
                   ng-blur="phoneFieldBlur()"/>
            <b className="tooltip tooltip-bottom-right">xxx@gmail.com</b>
        </label>
    </section>

}